export default "__VITE_ASSET__2CBOxbyW__"